import React, { useEffect, useState, useRef } from 'react'
import { apiPath1 } from "../services/apiConfig";

export default function PendingDocs() {
  const token = localStorage.getItem('token');

  const [pendingDocumentsCnt, setPendingDocumentsCnt] = useState([]);

  // 
  // Get Data
  //
  async function fetchPendingDocumentsCnt() {
    //  setLoading(true);
    try {
      // Fetch transaction status data
      const response = await fetch(apiPath1 + "PendingDocumentsCnt", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
      });
      const result = await response.json();
      if (result.status !== true) {
        throw new Error('Failed to fetch document status data');
      }
      setPendingDocumentsCnt(result.data);
    } catch (error) {
      console.error("Error fetching pending document count:", error);
    }
  }

  useEffect(() => {
    fetchPendingDocumentsCnt();
  }, []);


  return (
    <>
      <div className="cont__dashboard-pending ml16">
        <h5 className="">Pending Documents</h5>
        <div className="cont__dashboard-pending-component">
          {
            pendingDocumentsCnt.map((item, index) => {
              let type = item.Type;
              switch (type) {
                case 'D':
                  type = 'Indent';
                  break;
                case 'I':
                  type = 'Issue';
                  break;
                case 'R':
                  type = 'Return';
                  break;
                case 'T':
                  type = 'Transfer';
                  break;
                case 'X':
                  type = 'Repair';
                  break;
                default:
                  type = item.Type; // Keep original if no match
              }
              return (
                <div className="c12-g-l-2 align-items-center mr8">
                  <div className="box corner-round solid yellow mt4">{item.TrCount}</div>
                  <p className="sm medium center">{type}</p>
                </div>
              );
            })
          }
        </div>
      </div>
    </>
  );
}

